// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__7Zdc5","loader":"Loading_loader__rS1ky","spin":"Loading_spin__sCrfu","rotate":"Loading_rotate__OpWKL","rotateccw":"Loading_rotateccw__18Eo5"};